import {
    SET_SELECTED_BED,
    ADD_NEW_BED,
    RENAME_BED,
    DELETE_BED,
    HIDE_UNSAVED_CHANGES_DIALOG,
    SHOW_UNSAVED_CHANGES_DIALOG,
    SET_SELECTED_TAB_KEY,
    PROJECTS_CRUD_RESTORE_STATE,
    SUB_APPTOOLBAR_RESET_APP_STATE,
    UPDATE_PLACEHOLDER,
    DELETE_PLACEHOLDER,
    LOADING_BED,
    LOADING_MULTIBED_PROJECT,
    UPDATE_MULTIBED_SAVE_AS,
    UPDATE_BED_SAVE_AS, IS_DIRTY,
    HIDE_VOLUMES_COMPONENT,
    CALCULATIONS_CALL_API_SUCCESS,
    PIPE_SET_BED_DIMENSIONS,
    SET_MULTI_BED_OTHER_USER_DATA,
    SET_MULTI_BED_DESKTOP_ENABLED,
    APPTOOLBAR_RESET_APP_STATE,
    SET_UPDATE_PERIMETER,
    UPDATE_MULTIBED_SCALE,
    SHOW_MULTIBED_SCALE_DIALOG,
    UPDATE_SELECTED_BED,
    UPDATE_BEDS_PAYLOAD,
    SET_OVERALL_TOTAL,
} from "../lib/types";
import { createSelector } from "reselect";

/* Resolved lazily: store.js -> reducers/index.js -> this module, so a top-level
   store import leaves that cycle half-initialised depending on entry point. */
const getStore = () => require("../store").default;

const newRandomBed = {
    id: "temp-bed",
    name: "Bed 1",
    volume: 0,
    length: 0,
    width: 0,
    area: 0,
    chambers: 0,
    endCaps: 0,
    numberOfPipeRows: 0,
    lengthOutsideFittings: 0,
    lengthBetweenFittings: 0,
    lengthFittingsOnCenter: 0,
};

const testBeds = [
    newRandomBed,
];

const initialState = {
    beds: [...testBeds],
    selectedBed: testBeds[0],
    overallSiteVolume: 0,
    totalVolume: testBeds.reduce(( sum, b ) => sum + b.volume, 0),
    totalLength: testBeds.reduce(( sum, b ) => sum + b.length, 0),
    totalWidth: testBeds.reduce(( sum, b ) => sum + b.width, 0),
    totalArea: testBeds.reduce(( sum, b ) => sum + b.area, 0),
    totalChambers: testBeds.reduce(( sum, b ) => sum + b.chambers, 0),
    totalEndCaps: testBeds.reduce(( sum, b ) => sum + b.endCaps, 0),
    totalPipeRows: testBeds.reduce(( sum, b ) => sum + b.numberOfPipeRows, 0),
    totalLengthOutsideFittings: testBeds.reduce(( sum, b ) => sum + b.lengthOutsideFittings, 0),
    totalLengthBetweenFittings: testBeds.reduce(( sum, b ) => sum + b.lengthBetweenFittings, 0),
    totalLengthFittingsOnCenter: testBeds.reduce(( sum, b ) => sum + b.lengthFittingsOnCenter, 0),
    isOnOverviewTab: true,
    isUnsavedChangesDialogVisible: false,
    selectedTabKey: "overview",
    placeholders: [],
    loadingBed: false,
    loadingMultiBedProject: false,
    hideVolumesComponent: false,
    isDirty: false,
    otherUserId: null,
    otherUserTokens: null,
    isFromDesktop: false,
    isMultiBedDesktopEnabled: false,
    updatePerimeterOnBed: false,
    rescaleMultibeds: false,
    showScaleMultiBedWarning: false,
};

const getAllBedTotals = ( beds ) => {
    return {
        totalVolume: beds.reduce(( sum, b ) => sum + b.volume, 0),
        totalLength: beds.reduce(( sum, b ) => sum + b.length, 0),
        totalWidth: beds.reduce(( sum, b ) => sum + b.width, 0),
        totalArea: beds.reduce(( sum, b ) => sum + b.area, 0),
        totalChambers: beds.reduce(( sum, b ) => sum + b.chambers, 0),
        totalEndCaps: beds.reduce(( sum, b ) => sum + b.endCaps, 0),
        totalPipeRows: beds.reduce(( sum, b ) => sum + b.numberOfPipeRows, 0),
        totalLengthOutsideFittings: beds.reduce(( sum, b ) => sum + b.lengthOutsideFittings, 0),
        totalLengthBetweenFittings: beds.reduce(( sum, b ) => sum + b.lengthBetweenFittings, 0),
        totalLengthFittingsOnCenter: beds.reduce(( sum, b ) => sum + b.lengthFittingsOnCenter, 0),
    };
};

export let MultiBedReducer = ( state = initialState, action ) => {
    switch (action.type) {
        case SET_SELECTED_BED:
            return {
                ...state,
                selectedBed: [...state.beds].find(
                    bed => {
                        return bed.id === action.payload;
                    }),
            };

        case UPDATE_SELECTED_BED:
            let selectedBed = [...state.beds]
                .find(
                    bed => {
                        return bed.id === action.payload.bedId;
                    });
            selectedBed = { ...selectedBed, ...action.payload.updatedBedTotals };
            return {
                ...state,
                selectedBed: selectedBed,
            };

        case UPDATE_BEDS_PAYLOAD:
            const newTotalsRefresh = getAllBedTotals(action.payload.updatedBedsValues);
            return {
                ...state,
                beds: [...action.payload.updatedBedsValues],
                totalVolume: newTotalsRefresh.totalVolume,
                totalLength: newTotalsRefresh.totalLength,
                totalWidth: newTotalsRefresh.totalWidth,
                totalArea: newTotalsRefresh.totalArea,
                totalChambers: newTotalsRefresh.totalChambers,
                totalEndCaps: newTotalsRefresh.totalEndCaps,
                totalPipeRows: newTotalsRefresh.totalPipeRows,
                totalLengthBetweenFittings: newTotalsRefresh.totalLengthBetweenFittings,
                totalLengthFittingsOnCenter: newTotalsRefresh.totalLengthFittingsOnCenter,
                totalLengthOutsideFittings: newTotalsRefresh.totalLengthOutsideFittings,
            };

        case RENAME_BED:
            const updatedBeds = [...state.beds].map(bed => {
                return bed.id === action.payload.id ? { ...bed, name: action.payload.name } : bed;
            });
            return {
                ...state,
                beds: updatedBeds,
                selectedBed: updatedBeds.find(b => b.id === action.payload.id),
                placeholders: [...state.placeholders].map(p => {
                    return p.bedId === action.payload.id ? { ...p, bedName: action.payload.name } : p;
                }),
            };

        case ADD_NEW_BED:
            let newBed = {
                ...newRandomBed,
                id: action.payload.id,
                name: action.payload.name,
            };
            const calcs = action.payload.calcs;
            if (calcs) {
                newBed = {
                    ...newBed,
                    volume: calcs.volume,
                    length: calcs.length,
                    width: calcs.width,
                    area: calcs.area,
                    chambers: calcs.chambers,
                    endCaps: calcs.endCaps,
                    numberOfPipeRows: calcs.numberOfPipeRows,
                    lengthBetweenFittings: calcs.lengthBetweenFittings,
                    lengthFittingsOnCenter: calcs.lengthFittingsOnCenter,
                    lengthOutsideFittings: calcs.lengthOutsideFittings,
                    chamberTypeName: calcs.chamberTypeName,
                    pipeTypeName: action.payload.pipeTypeName,   // Pipe fitting
                    pipeSizeNominalDiameter: action.payload.pipeSizeNominalDiameter,

                };
            }
            let newBedsList = [...state.beds, newBed];
            const newTotals = getAllBedTotals(newBedsList);
            return {
                ...state,
                beds: newBedsList,
                selectedBed: newBed,
                totalVolume: newTotals.totalVolume,
                totalLength: newTotals.totalLength,
                totalWidth: newTotals.totalWidth,
                totalArea: newTotals.totalArea,
                totalChambers: newTotals.totalChambers,
                totalEndCaps: newTotals.totalEndCaps,
                totalPipeRows: newTotals.totalPipeRows,
                totalLengthBetweenFittings: newTotals.totalLengthBetweenFittings,
                totalLengthFittingsOnCenter: newTotals.totalLengthFittingsOnCenter,
                totalLengthOutsideFittings: newTotals.totalLengthOutsideFittings,
                placeholders: [...state.placeholders, action.payload.placeholderSettings],
            };

        case DELETE_BED:
            const beds = [...state.beds].filter(b => b.id !== action.payload);
            const totals = getAllBedTotals(beds);
            return {
                ...state,
                beds: beds,
                selectedBed: beds[0],
                totalVolume: totals.totalVolume,
                totalLength: totals.totalLength,
                totalWidth: totals.totalWidth,
                totalArea: totals.totalArea,
                totalChambers: totals.totalChambers,
                totalEndCaps: totals.totalEndCaps,
                totalPipeRows: totals.totalPipeRows,
                totalLengthBetweenFittings: totals.totalLengthBetweenFittings,
                totalLengthFittingsOnCenter: totals.totalLengthFittingsOnCenter,
                totalLengthOutsideFittings: totals.totalLengthOutsideFittings,
            };

        case UPDATE_PLACEHOLDER:
            const updatedPlaceholder = state
                .placeholders
                .map(placeholder => {
                    if (placeholder.bedId === action.payload.placeholderSettings.bedId) {
                        return action.payload.placeholderSettings;
                    }
                    return placeholder;
                });
            return {
                ...state,
                placeholders: updatedPlaceholder,
            };

        case DELETE_PLACEHOLDER:
            let updatedPlaceholderAfterRemove = state.placeholders;
            for (let i = updatedPlaceholderAfterRemove.length - 1; i >= 0; --i) {
                if (updatedPlaceholderAfterRemove[i].bedId === action.payload.placeholderId)
                    updatedPlaceholderAfterRemove.splice(i, 1);
            }
            return {
                ...state,
                placeholders: updatedPlaceholderAfterRemove,
            };

        case SHOW_UNSAVED_CHANGES_DIALOG:
            return {
                ...state,
                isUnsavedChangesDialogVisible: true,
            };

        case HIDE_UNSAVED_CHANGES_DIALOG:
            return {
                ...state,
                isUnsavedChangesDialogVisible: false,
            };

        case SET_SELECTED_TAB_KEY:
            return {
                ...state,
                selectedTabKey: action.payload,
                isOnOverviewTab: action.payload.toLowerCase() === "overview",
            };

        case PROJECTS_CRUD_RESTORE_STATE:
            let rState = action.payload.multiBed;
            let isDeskTop = action.payload.isDeskTop;
            if (rState !== undefined) {
                rState = {
                    ...state,
                    ...rState,
                    selectedBed: rState.beds[rState.beds.length - 1],
                    selectedTabKey: "overview",
                    isOnOverviewTab: true,
                    isUnsavedChangesDialogVisible: false,
                    hideVolumesComponent: false,
                    isMultiBedDesktopEnabled: isDeskTop,
                    isFromDesktop: isDeskTop,
                };
                return {
                    ...state,
                    ...rState,
                };
            } else {
                return initialState;
            }

        case UPDATE_MULTIBED_SAVE_AS:
            let prevBedsState = state.beds;
            let newBedsArray = action.payload.newBedsArray,
                newPlaceholdersArray = action.payload.newPlaceholdersArray;

            const newUpdatedBedsArray = prevBedsState
                .map(bed => {
                    const bedMeta = newBedsArray.find(b => {
                        return b.name === bed.name;
                    });
                    bed.name = bedMeta.name;
                    bed.id = bedMeta.id;
                    return bed;
                });

            const updatedState = {
                beds: newUpdatedBedsArray,
                placeholders: newPlaceholdersArray,
                selectedBed: state.beds[0],
                selectedTabKey: "overview",
            };
            return {
                ...state,
                ...updatedState,
            };

        case UPDATE_BED_SAVE_AS:
            let prevBedsSt = state.beds;
            let prevPlaceholdersSt = state.placeholders;
            let bedMetaData = action.payload.bedMetaData;

            const updatedBedsArray = prevBedsSt
                .map(bed => {
                    if (bedMetaData.name === bed.name)
                        bed.id = bedMetaData.id;
                    return bed;
                });

            const updatedPlaceholderArray = prevPlaceholdersSt
                .map(placeholder => {
                    if (bedMetaData.oldId === placeholder.bedId)
                        placeholder.bedId = bedMetaData.id;

                    return placeholder;
                });

            return {
                ...state,
                beds: updatedBedsArray,
                placeholders: updatedPlaceholderArray,
            };

        case LOADING_BED:
            return {
                ...state,
                loadingBed: action.payload.loadingBed,
            };

        case IS_DIRTY:
            return {
                ...state,
                isDirty: action.payload,
            };

        case HIDE_VOLUMES_COMPONENT:
            return {
                ...state,
                hideVolumesComponent: action.payload,
            };

        case LOADING_MULTIBED_PROJECT:
            return {
                ...state,
                loadingMultiBedProject: action.payload.loadingMultiBedProject,
            };

        case SUB_APPTOOLBAR_RESET_APP_STATE:
        case APPTOOLBAR_RESET_APP_STATE:
            return initialState;

        case CALCULATIONS_CALL_API_SUCCESS:
            let bedToUpdate = null;
            if (state.beds.length) {
                bedToUpdate = state.isOnOverviewTab
                    ? state.beds[state.beds.length - 1]
                    : state.beds.find(b => b.id === state.selectedTabKey);
            }
            // Since there's a glitch when the clauclation gets run when adding a bed, need to check for isFinite here
            if (bedToUpdate && isFinite(action.payload.calculations.systemLength)) {
                let updatedBeds = [...state.beds].map(b => {
                    if (b.id === bedToUpdate.id) {
                        return {
                            ...b,
                            volume: action.payload.volume,
                            length: action.payload.calculations.systemLength,
                            width: action.payload.calculations.systemWidth,
                            area: action.payload.calculations.area,
                            chambers: action.payload.calculations.numChambers,
                            endCaps: action.payload.calculations.numEndCaps,
                            chamberTypeName: action.payload.chamberTypeName,

                        };
                    }
                    return b;
                });
                const totals = getAllBedTotals(updatedBeds);
                return {
                    ...state,
                    beds: updatedBeds,
                    selectedBed: updatedBeds.find(b => b.id === bedToUpdate.id),
                    totalVolume: totals.totalVolume,
                    totalLength: totals.totalLength,
                    totalWidth: totals.totalWidth,
                    totalArea: totals.totalArea,
                    totalChambers: totals.totalChambers,
                    totalEndCaps: totals.totalEndCaps,
                };
            } else {
                return state;
            }

        case PIPE_SET_BED_DIMENSIONS:
            let pipeBedToUpdate = null;
            if (state.beds.length) {
                pipeBedToUpdate = state.isOnOverviewTab
                    ? state.beds[state.beds.length - 1]
                    : state.beds.find(b => b.id === state.selectedTabKey);
            }

            if (pipeBedToUpdate) {
                let updatedBeds = [...state.beds].map(bed => {
                    if (bed.id === pipeBedToUpdate.id) {
                        return {
                            ...bed,
                            volume: action.payload.volume,
                            length: action.payload.dimensions.length.ft,
                            width: action.payload.dimensions.width.ft,
                            area: action.payload.area,
                            numberOfPipeRows: action.payload.numberOfPipeRows,
                            lengthOutsideFittings: action.payload.pipeBedDimensions.height.ft,
                            lengthBetweenFittings: action.payload.rowBedDimensions.height.ft,
                            lengthFittingsOnCenter: action.payload.centerFittingDimensions.height.ft,
                            // chamberTypeName: action.payload.chamberTypeName,
                            pipeTypeName: action.payload.pipeTypeName,   // Pipe fitting
                            pipeSizeNominalDiameter: action.payload.pipeSizeNominalDiameter,

                        };
                    }
                    return bed;
                });
                const totals = getAllBedTotals(updatedBeds);
                return {
                    ...state,
                    beds: updatedBeds,
                    selectedBed: updatedBeds.find(b => b.id === pipeBedToUpdate.id),
                    totalVolume: totals.totalVolume,
                    totalLength: totals.totalLength,
                    totalWidth: totals.totalWidth,
                    totalArea: totals.totalArea,
                    totalLengthBetweenFittings: totals.totalLengthBetweenFittings,
                    totalLengthFittingsOnCenter: totals.totalLengthFittingsOnCenter,
                    totalLengthOutsideFittings: totals.totalLengthOutsideFittings,
                };
            } else {
                return state;
            }

        case SET_MULTI_BED_OTHER_USER_DATA:
            return {
                ...state,
                otherUserId: action.payload.id,
                otherUserTokens: action.payload.tokens,
            };

        case SET_MULTI_BED_DESKTOP_ENABLED:
            return {
                ...state,
                isFromDesktop: action.payload.isFromDesktop,
                isMultiBedDesktopEnabled: action.payload.enabled,
            };

        case SET_UPDATE_PERIMETER:
            return {
                ...state,
                updatePerimeterOnBed: action.payload.updatePerimeterOnBed,
            };

        case UPDATE_MULTIBED_SCALE:
            return {
                ...state,
                rescaleMultibeds: action.payload.rescaleMultibeds,
            };

        case SHOW_MULTIBED_SCALE_DIALOG:
            return {
                ...state,
                showScaleMultiBedWarning: action.payload.showScaleMultiBedWarning,
            };

        case SET_OVERALL_TOTAL:
            return {
                ...state,
                overallSiteVolume: action.payload,
            };

        default:
            return state;
    }
};

// SELECTORS
const getMultibedBeds = state => state.multiBed.beds;
const getMultibedPlaceholders = state => state.multiBed.placeholders;
const getSelectedBed = state => state.multiBed.selectedBed;
const MultibedSelectors = {

    getLastBed: () => {
        try {
            const getLastBed = createSelector(
                [getMultibedBeds],
                ( beds ) => {
                    return beds[beds.length - 1];
                });
            return getLastBed(getStore().getState());
        } catch (error) {
            console.error(`MultibedSelectors.isMultiBedProject() :: ${error.message}`);
        }
    },

    getPlaceholderById: ( bedId ) => {
        try {
            const getPlaceholder = createSelector(
                [getMultibedPlaceholders],
                ( placeholder ) => {
                    return placeholder.find(( ph ) => {
                        return ph.bedId === bedId;
                    });
                });
            return getPlaceholder(getStore().getState());
        } catch (error) {
            console.error(`MultibedSelectors.isMultiBedProject() :: ${error.message}`);
        }
    },

    getBedById: ( id ) => {
        try {
            const getBedById = createSelector(
                [getMultibedBeds],
                ( beds ) => {
                    return beds.find(( bed ) => {
                        return bed.id === id;
                    });
                });
            return getBedById(getStore().getState());
        } catch (error) {
            console.error(`MultibedSelectors.isMultiBedProject() :: ${error.message}`);
        }
    },

    getCurrentBed: () => {
        try {
            const getCurrentBed = createSelector(
                [getSelectedBed],
                ( selectedBed ) => {
                    return selectedBed;
                });
            return getCurrentBed(getStore().getState());
        } catch (error) {
            console.error(`MultibedSelectors.isMultiBedProject() :: ${error.message}`);
        }
    },

    getAllBeds: () => {
        try {
            const getAllBeds = createSelector(
                [getMultibedBeds],
                ( beds ) => beds);
            return getAllBeds(getStore().getState());
        } catch (error) {
            console.error(`MultibedSelectors.isMultiBedProject() :: ${error.message}`);
        }
    },
};

export default MultibedSelectors;



// WEBPACK FOOTER //
// ./src/reducers/multi-bed-reducer.js